import type { BeforeRequestHook } from "ky";
import ky from "ky";
import { useAccountService } from "ls/features/user/useAccountService";
import { miniProfilerResponseHook, parseCloudJsonResponse, problemDetailsErrorHook } from "../common/server";
import { cloudApiUrl } from "../urls";

const beforeRequestHooks = new Set<BeforeRequestHook>();

const dynamicBeforeRequestHook: BeforeRequestHook = async (request, options, state) => {
  let hookResult = request;

  for (const hook of beforeRequestHooks) {
    const result = await hook(hookResult, options, state);

    if (result instanceof Request) {
      hookResult = result;
      break;
    }

    if (result instanceof Response) {
      return result;
    }
  }

  return hookResult;
};

export function addBeforeRequestHook(hook: BeforeRequestHook) {
  beforeRequestHooks.add(hook);
}

export function deleteBeforeRequestHook(hook: BeforeRequestHook) {
  beforeRequestHooks.delete(hook);
}

export const server = ky.create({
  prefixUrl: cloudApiUrl,
  credentials: import.meta.env.DEV ? "include" : undefined,
  timeout: import.meta.env.DEV ? false : undefined,
  retry: { limit: 0 },
  parseJson: parseCloudJsonResponse,
  hooks: {
    beforeRequest: [
      request => {
        const accountService = useAccountService();
        if (accountService.user.value) {
          const token = accountService.user.value.authToken;
          request.headers.set("Authorization", token);
        }
      },
      dynamicBeforeRequestHook,
    ],
    afterResponse: [
      miniProfilerResponseHook,
    ],
    beforeError: [
      problemDetailsErrorHook,
    ],
  },
});
